import { useEffect, useState } from 'react';
import { alphabetColors } from "@/components/video/videoComments/main/constants"

import "./style.css";

export default function InitialAvatar(props: any) {
    const { name, isHidden } = props;
    const [bgColor, setBgColor] = useState('#000'); // default fallback

    const getFirstLetterCapital = (str: string) => {
        if (!str) return '';
        return str.trim().charAt(0).toUpperCase();
    };

    const getRandomColor = () => {
        const color = alphabetColors[getFirstLetterCapital(name)] || "#b2b2b2";
        // const letters = '0123456789ABCDEF';
        // let color = '#';
        // for (let i = 0; i < 6; i++) {
        //     color += letters[Math.floor(Math.random() * 16)];
        // }
        return color;
    };

    useEffect(() => {
        setBgColor(getRandomColor());
    }, []);

    return (
        <div
            className="initialAvatar"
            style={{
                backgroundColor: bgColor,
                visibility : isHidden ? 'hidden' : 'visible'
            }}>
            {getFirstLetterCapital(name)}
        </div>
    );
}
